module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-CondIt.e10ed3c.woff";